import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import "./ImportInvitationsModal.css";
import { toast } from "react-toastify";


const API = process.env.REACT_APP_API_URL;

function ImportInvitationsModal({ campaignId, onClose, onImported }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // ===============================
  // Leer archivo Excel / CSV
  // ===============================
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = evt.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, {
        defval: "",
        raw: true,
      });

      setRows(json);
    };

    reader.readAsBinaryString(file);
  };

  const formatPreviewValue = (value, key) => {
    if (!value) return "";

    // Si es campo de fecha
    if (key.toLowerCase().includes("fecha")) {

      // caso excel numérico (46010)
      if (!isNaN(value)) {
        const fecha = XLSX.SSF.parse_date_code(value);
        return `${String(fecha.d).padStart(2,"0")}/${String(fecha.m).padStart(2,"0")}/${fecha.y}`;
      }

      // si ya viene como string
      return value;
    }

    return value;
  };

  // ===============================
  // Enviar al backend
  // ===============================
  const submit = async () => {
    if (rows.length === 0) return;

    try {
      setLoading(true);

      const resp = await axios.post(
        `${API}/api/campaigns/${campaignId}/invitations`,
        { people: rows },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("✅ Resultado import:", resp.data);
      toast.success(`¡Importación lista! ${resp.data.inserted} insertados / ${resp.data.skipped} omitidos`);


      onImported();
      onClose();

    } catch (err) {
      console.error("Error importando base", err);
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="camp-modal-overlay">
    <div className="cam-import-modal">

      {/* HEADER */}
      <div className="cam-import-header">
        <h3 className="cam-import-title">Importación de Base</h3>
      </div>

      {/* CONTENIDO */}
      <div className="cam-import-body">

        <div className="cam-import-field">
          <div className="cam-import-file">
            <input
              type="file"
              id="campaign-file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFile}
              hidden
            />

            <label
              htmlFor="campaign-file"
              className="cam-import-file-btn"
            >
              Seleccionar archivo .xls
            </label>

            <span className="cam-import-file-name">
              {rows.length > 0
                ? "Archivo cargado"
                : "Ningún archivo seleccionado"}
            </span>
          </div>
        </div>

        {rows.length > 0 && (
          <>
            <p className="cam-import-helper">
              Vista previa ({rows.length} registros)
            </p>

            <div className="cam-import-preview">
              <table>
                <thead>
                  <tr>
                    {Object.keys(rows[0]).slice(0, 28).map((k) => (
                      <th key={k}>{k}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.slice(0, 28).map((r, i) => (
                    <tr key={i}>
                      {Object.keys(rows[0]).slice(0, 28).map((k) => (
                        <td key={k}>{formatPreviewValue(r[k], k)}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

      </div>

      {/* ACCIONES */}
      <div className="cam-import-actions">
        <button
          className="cam-btn cam-btn-secondary"
          onClick={onClose}
        >
          Cancelar
        </button>

        <button
          className="cam-btn cam-btn-primary"
          onClick={submit}
          disabled={loading || rows.length === 0}
        >
          {loading ? "Importando..." : "Confirmar importación"}
        </button>
      </div>

    </div>
  </div>
);


}

export default ImportInvitationsModal;
